import { generatePDF } from "@/utils/generatePDF";

import {
  EXPORTABLES_PREVIEW_FORM_ID,
  EXPORTABLES_PREVIEW_PRINTING_CLASSNAME,
} from "@/components/AIComponents/ExportablesModal/ExportablesModal.constants";
import type { TemplateDefinition } from "@/components/AIComponents/ExportablesModal/templates/registry";
import type { ExportablesDataTypes } from "@/types/models/Exportables.interface";

export function getDownloadHandler({
  selectedExportable,
}: {
  selectedExportable: TemplateDefinition<ExportablesDataTypes>;
}) {
  return async () => {
    try {
      const label = selectedExportable.label || selectedExportable.title;
      const filename = `${label}.pdf`;

      const templateForm = document.getElementById(
        EXPORTABLES_PREVIEW_FORM_ID,
      )!;
      const clonedTemplateForm = templateForm.cloneNode(true) as HTMLElement;
      clonedTemplateForm.classList.add(EXPORTABLES_PREVIEW_PRINTING_CLASSNAME);
      const pdfBlob = await generatePDF(clonedTemplateForm, {
        filename,
        format: "letter",
        orientation: selectedExportable.pdfOptions.orientation,
      });

      // Create a URL for the blob and trigger download
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
}
